import { useNavigate } from "react-router-dom";
import { Image } from "./style";

const Logo = () => {
  const navigate = useNavigate();
  const navHome = () => navigate("/");

  return (
    <Image onClick={navHome} src="/assets/logo.svg" alt="Wallverse's logomark" />
  );
};

export default Logo;
